/* global google */
import React, { useState, useEffect } from 'react';
import { Map, useMap } from '@vis.gl/react-google-maps';
// import { MarkerClusterer } from '@googlemaps/markerclusterer';
import {AdvancedMarkerFlex} from './AdvancedMarkerFlex';
import markericonOver from "assets/img/maps/over.png";
import classNames from 'classnames';
import './flex.css';

import moment from "moment";

const mapstyle = [
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    {
        featureType: "administrative.locality",
        elementType: "labels.text.fill",
        stylers: [{ color: "#d59563" }],
    },
    {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "poi",
        elementType: "labels.text.fill",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "poi.park",
        elementType: "geometry",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "poi.park",
        elementType: "labels.text.fill",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: 'road',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "road",
        elementType: "geometry",
        stylers: [{ color: "#38414e" }],
    },
    {
        featureType: "road",
        elementType: "geometry.stroke",
        stylers: [{ color: "#212a37" }],
    },
    {
        featureType: "road",
        elementType: "labels.text.fill",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "road.highway",
        elementType: "geometry",
        stylers: [{ color: "#746855" }],
    },
    {
        featureType: "road.highway",
        elementType: "geometry.stroke",
        stylers: [{ color: "#1f2835" }],
    },
    {
        featureType: "road.highway",
        elementType: "labels.text.fill",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: 'transit',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "transit",
        elementType: "geometry",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "transit.station",
        elementType: "labels.text.fill",
        stylers: [{ visibility: 'off' }]
    },
    {
        featureType: "water",
        elementType: "geometry",
        stylers: [{ color: "#17263c" }],
    },
    {
        featureType: "water",
        elementType: "labels.text.fill",
        stylers: [{ color: "#515c6d" }],
    },
    {
        featureType: "water",
        elementType: "labels.text.stroke",
        stylers: [{ visibility: 'off' }]
    },
];

export default function MapComponent(props) {
    const { bacslist, onMarkerClickCallback, activesite, overSiteId, bacsrequests, onInfoWindowClose } = props;

    const [markers, setMarkers] = useState();
    const [bounds, setBounds] = useState();
    const [clicked, setClicked] = useState(false);
    const [hovered, setHovered] = useState(false);

    const map = useMap();

    useEffect(() => {
        console.log("rebuildmarker");
        reBuildMarkers(activesite, overSiteId);
    }, [activesite, overSiteId])

    useEffect(() => {
        if (!map)
            return;
        var styledMapType = new google.maps.StyledMapType(mapstyle);
        map.mapTypes.set("styled_map", styledMapType);
        map.setMapTypeId("styled_map");
        var boundsTmp = new google.maps.LatLngBounds();
        var markersTmp = [];
        if (bacslist.length == 0) {
            boundsTmp.extend(new google.maps.LatLng(50.1, 2.4));
            boundsTmp.extend(new google.maps.LatLng(42.7, 2.4));
        }
        bacslist.map((bacs, i) => {
            boundsTmp.extend(new google.maps.LatLng(bacs.location.lat, bacs.location.lng));
            var marker = buildMarker(bacs, null, null);
            markersTmp.push(marker);
        })
        map.fitBounds(boundsTmp);

        setMarkers(markersTmp);
        setBounds(boundsTmp);
    }, [bacslist, map, bacsrequests])



    const buildMarker = (bacs, activesite, overSiteId) => {
        var marker;
        var animationtodisplay = 0;
        var labeltodisplay = '';
        var icontodisplay = markericonOver;
        var zindex = 0;
        var activemarker = false;
        if (overSiteId == bacs.bacsid) {
            animationtodisplay = google.maps.Animation.BOUNCE;
            icontodisplay = markericonOver;
        }
        if (activesite && activesite.bacsid === bacs.bacsid) {
            icontodisplay = markericonOver;
            zindex = 9999;
            activemarker = true;
        }
        console.log(bacs);
        console.log(bacsrequests);
        let requeststatus = "norequest";
        let now = moment();
        let bacsrequestlist = bacsrequests.filter((request) => request.bacsid === bacs.bacsid);
        console.log(bacsrequestlist);
        if (bacsrequestlist) {
            bacsrequestlist.forEach(request => {
                if (request.power && request.power.length > 0) {
                    request.power.forEach(power => {
                        if (moment(power.start).isSameOrBefore(now) && moment(power.end).isSameOrAfter(now)) {
                            //requete en cours
                            requeststatus = "activecharge";
                        }
                        else if (requeststatus !== "activecharge" && moment(power.start).isSameOrAfter(now)) {
                            //requete à venir
                            requeststatus = "programmedcharge";
                        }
                    });
                }

            });
        }
        console.log(bacs.bacsid, requeststatus);
        let capaclass = bacs.parameters.totalcapacity < 30 ? "smallcapa" : bacs.parameters.totalcapacity < 100 ? "mediumcapa" : "bigcapa";
        marker = <AdvancedMarkerFlex
            key={bacs.bacsid}
            bacsid={bacs.bacsid}
            position={bacs.location}
            onClick={(event) => onMarkerClick(bacs)}
            name={bacs.name}
            site={bacs}
            title={bacs.name}
            infowindowOpen={activemarker}
            onInfoWindowClose={onInfoWindowClose}
            bacsrequestlist={bacsrequestlist}
            //clickable={true}
            //icon={icontodisplay}
            //animation={animationtodisplay}
            //zIndex={zindex}
            className={classNames('flex-marker', { clicked, hovered }, capaclass, requeststatus)}
        >
            
        </AdvancedMarkerFlex>

        return marker;
    };

    const onMarkerClick = (destination) => {
        onMarkerClickCallback(destination);
    };

    const reBuildMarkers = (activeSiteId, overSiteId) => {
        var markersTmp = [];
        bacslist.map((bacs, i) => {
            var marker = buildMarker(bacs, activeSiteId, overSiteId);
            markersTmp.push(marker);
        })
        setMarkers(markersTmp);
    };

    // const clusterer = useMemo(() => {
    //   if (!map) return null;

    //   return new MarkerClusterer({map});
    // }, [map]);

    // useEffect(() => {
    //   if (!clusterer) return;

    //   clusterer.clearMarkers();
    //   clusterer.addMarkers(Object.values(markers));
    // }, [clusterer, markers]);

    return (
        <Map
            defaultCenter={{ lat: 46.778476, lng: 2.392557 }}
            defaultZoom={10}
            mapId='888-777-666'
            // mapTypeId={'terrain'}
            disableDefaultUI={true}
            style={{ borderRadius: "20px" }}
        >
            {markers}
        </Map>


    );
}

